import mbc from "~/shared/functions/mbc";

class LoggerClass implements Logger {
	logs: Log[];
	private eventTarget: EventTarget;

	constructor(logs?: Log[]) {
		this.logs = logs ?? [];
		this.eventTarget = new EventTarget();
	}

	log(message: any) {
		const newLog: Log = {
			id: crypto.randomUUID(),
			message,
		};
		this.logs.push(newLog);

		const updatedLogs = [...this.logs];
		this.eventTarget.dispatchEvent(new CustomEvent("log-event", { detail: updatedLogs }));
	}

	clearLogs() {
		this.logs.length = 0;
		this.eventTarget.dispatchEvent(new CustomEvent("log-event", { detail: [] }));
	}

	updateLogs(logs: Log[]) {
		this.logs = logs;
		this.eventTarget.dispatchEvent(new CustomEvent("log-event", { detail: this.logs }));
	}

	subscribe(callback: (logs: Log[]) => void) {
		const func = (e) => callback(e.detail);
		this.eventTarget.addEventListener("log-event", func);
		return () => {
			this.eventTarget.removeEventListener("log-event", func);
		};
	}
}

globalThis.debugLogger = new LoggerClass(mbc.getInitialState().debugLogs);
